import { useState, useEffect } from 'react';

const SESSION_KEY = 'vroom_user';

export function useAuth() {
  const [user, setUser] = useState(null);

  useEffect(() => {
    const saved = sessionStorage.getItem(SESSION_KEY);
    if (saved) {
      try { setUser(JSON.parse(saved)); } catch {}
    }
    fetch('https://v-room.app/api/auth/web/session', { credentials: 'include' })
      .then(async (response) => response.ok ? response.json() : null)
      .then((data) => {
        if (!data?.user) return;
        const restored = { ...data.user, token: data.token, csrfToken: data.csrfToken };
        setUser(restored);
        sessionStorage.setItem(SESSION_KEY, JSON.stringify(restored));
      })
      .catch(() => {});
  }, []);

  const login = (userData) => {
    setUser(userData);
    sessionStorage.setItem(SESSION_KEY, JSON.stringify(userData));
  };

  const logout = () => {
    fetch('https://v-room.app/api/auth/web/logout', { method: 'POST', credentials: 'include' }).catch(() => {});
    setUser(null);
    sessionStorage.removeItem(SESSION_KEY);
  };

  return { user, login, logout };
}
